import reCheckbox from "./src/index.vue";

reCheckbox.install = function (Vue) {
  Vue.component(reCheckbox.name, reCheckbox);
};

export default reCheckbox;
